import {io, Socket} from "socket.io-client";

const socket: Socket = io('https://gscoworking.com', {
    path: '/socket.io/',
    transports: ['websocket'],
    forceNew: false,
    reconnection: true,
    // Оптимизация для слабых устройств
    timeout: 20000,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
    autoConnect: true,
}); // Подключение к серверу Socket.IO

export default socket
